import palette from './palette.mjs';

const { primary } = palette;

export default {
  MuiCheckbox: {
    root: {
      color: primary.text6,
      padding: 8,
      borderRadius: 8,

      marginRight: 4,
      '&.MuiCheckbox-colorPrimary.Mui-checked:hover': {
        backgroundColor: 'rgba(99, 239, 255, 0.04)', // NOTE: primary color
      },
      '&.MuiCheckbox-colorPrimary.Mui-checked:hover .MuiIconButton-label path': {
        fill: primary.light,
      },
      '&.MuiCheckbox-colorPrimary.MuiCheckbox-indeterminate:hover .MuiIconButton-label path': {
        fill: primary.light,
      },
      '& .MuiTouchRipple-child': {
        borderRadius: 8,
      },
    },
    colorPrimary: {
      '&:hover': {
        backgroundColor: 'rgba(99, 239, 255, 0.04)', // NOTE: primary color
      },
      '&.MuiCheckbox-indeterminate': {
        color: primary.main,
      },
      '&.Mui-disabled': {
        opacity: 0.4,
        color: primary.text6,
        '&.Mui-checked, &.MuiCheckbox-indeterminate': {
          color: primary.main,
        },
      },
    },
  },
};
